import * as React from "react";
import { Box, Grid } from "@mui/material";

export default function EmptyList({ image, image2 }: any) {
    return (
        <Box >
            <Grid container style={{ marginTop: '20vh', justifyContent: 'center' }} >
                <img src={image} />
            </Grid>
            <Grid container style={{ marginTop: '2vh', justifyContent: 'center' }} >
                {image2 ?
                    <span style={{ fontSize: '20px', fontWeight: 'bold' }}>سبد خرید شما خالی است!</span> : ""
                }
            </Grid>
        </Box >
    );
}


